import React, { useEffect, useState } from 'react';
import {

  Col,

  Row,
} from 'reactstrap';

import { useLocation, withRouter } from 'react-router-dom';
import NpsReport from '../../../shared/components/reports/NpsReport';
import Page from '../../../components/Layout/Page';


const ReportingPage = () => {
   const [batchId, setBatchId] = useState(null);
  const location = useLocation();


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const idFromQueryParam = searchParams.get('report_id'); // Assuming the query param is named batchId
    setBatchId(idFromQueryParam);
  }, [location]);

    return (
      <Col


      >

        <Row>
          <Col style={{ margin: '0', padding: '0' }}>
           {batchId && <NpsReport batchId={batchId} />}
            </Col>

        </Row>

      </Col>
    );

};

export default ReportingPage;
